import { render } from "./SupplierSectionContact.vue?vue&type=template&id=b6921886"
import script from "./SupplierSectionContact.vue?vue&type=script&lang=js"
export * from "./SupplierSectionContact.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__